export const DEFAULT_JOURNALS = [
  {
    id: "ijcm",
    title: "International Journal of Clinical Medicine",
    short_title: "IJCM",
    description: "High-impact clinical medicine, diagnostics, and patient care research.",
    image_url: "https://images.pexels.com/photos/3735715/pexels-photo-3735715.jpeg?auto=compress&cs=tinysrgb&w=800",
    issn: "2345-6789",
    frequency: "Monthly",
    impact_factor: "3.85"
  },
  {
    id: "ijmcrr",
    title: "International Journal of Medical - Clinical Research & Reviews",
    short_title: "IJMCRR",
    description: "International, fully peer-reviewed academic journal dedicated to publishing comprehensive and reliable research in medicine and science research.",
    image_url: "/ijmcrr_cover.jpg",
    issn: "2993-8411",
    frequency: "Monthly",
    impact_factor: "4.25"
  },
  {
    id: "ijppr",
    title: "International Journal of Psychiatry and Psychology Research",
    short_title: "IJPPR",
    description: "An open access, peer-reviewed journal considering articles on all aspects of Psychiatry, Mental Disorders, Behavioural Science, and Neuroscience.",
    image_url: "/ijppr_cover.jpg",
    issn: "2993-842X",
    frequency: "Monthly",
    impact_factor: "4.15"
  },
  {
    id: "ijscrm",
    title: "International Journal of Stem Cell Research and Medicine",
    short_title: "IJSCRM",
    description: "A peer-reviewed, open-access journal dedicated to the advancement of stem cell research, regenerative medicine, and clinical applications.",
    image_url: "/ijscrm_cover.jpg",
    issn: "2993-8438",
    frequency: "Monthly",
    impact_factor: "4.45"
  },
  {
    id: "jjcm",
    title: "Japan Journal of Clinical Medicine",
    short_title: "JJCM",
    description: "An SCIE-ranked peer-reviewed, open access journal publishing original translational, preclinical, and clinical research across all areas of medicine.",
    image_url: "/jjcm_cover.jpg",
    issn: "2993-8446",
    frequency: "Monthly",
    impact_factor: "4.35"
  },
  {
    id: "ijccr",
    title: "International Journal of Cardiology & Cardiovascular Research",
    short_title: "IJCCR",
    description: "A peer-reviewed open-access online journal focused primarily on cardiology therapeutics, cardiovascular surgery, and vascular sciences.",
    image_url: "/ijccr_cover.jpg",
    issn: "2993-8454",
    frequency: "Monthly",
    impact_factor: "4.65"
  },
  {
    id: "jcrr",
    title: "Journal of Clinical Research and Reviews",
    short_title: "JCRR",
    description: "An international open-access journal publishing research and reviews in general & scientific medical research and clinical practice.",
    image_url: "/jcrr_cover.jpg",
    issn: "2993-8462",
    frequency: "Monthly",
    impact_factor: "4.30"
  },
  {
    id: "jps",
    title: "Journal of Pharmaceutical Sciences",
    short_title: "JPS",
    description: "Drug discovery, pharmacology, and pharmaceutical technology.",
    image_url: "https://images.pexels.com/photos/3683074/pexels-photo-3683074.jpeg?auto=compress&cs=tinysrgb&w=800",
    issn: "2345-6790",
    frequency: "Bimonthly",
    impact_factor: "4.12"
  },
  {
    id: "ijs",
    title: "International Journal of Surgery",
    short_title: "IJS",
    description: "Surgical techniques, innovations, and operative outcomes.",
    image_url: "https://images.pexels.com/photos/4225880/pexels-photo-4225880.jpeg?auto=compress&cs=tinysrgb&w=800",
    issn: "2345-6791",
    frequency: "Monthly",
    impact_factor: "3.42"
  },
  {
    id: "ijon",
    title: "International Journal of Oncology",
    short_title: "IJON",
    description: "Cancer biology, clinical oncology, and therapeutic breakthroughs.",
    image_url: "https://images.pexels.com/photos/3825586/pexels-photo-3825586.jpeg?auto=compress&cs=tinysrgb&w=800",
    issn: "2345-6792",
    frequency: "Quarterly",
    impact_factor: "4.78"
  }
];

export const DEFAULT_MEMBERS = [
  {
    id: "1",
    name: "Dr. Sarah Mitchell",
    title: "Editor-in-Chief",
    institution: "Harvard Medical School",
    country: "USA",
    specialty: "Internal Medicine & Clinical Research",
    image_url: "https://images.pexels.com/photos/5215024/pexels-photo-5215024.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: "2",
    name: "Prof. James Chen",
    title: "Associate Editor",
    institution: "University of Oxford",
    country: "UK",
    specialty: "Cardiology & Vascular Medicine",
    image_url: "https://images.pexels.com/photos/5327585/pexels-photo-5327585.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: "3",
    name: "Dr. Maria Rodriguez",
    title: "Senior Editor",
    institution: "Karolinska Institute",
    country: "Sweden",
    specialty: "Pharmaceutical Sciences & Oncology",
    image_url: "https://images.pexels.com/photos/5452293/pexels-photo-5452293.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: "4",
    name: "Prof. Ahmed Hassan",
    title: "Editorial Board Member",
    institution: "University of Tokyo",
    country: "Japan",
    specialty: "Emergency Medicine & Surgery",
    image_url: "https://images.pexels.com/photos/6129437/pexels-photo-6129437.jpeg?auto=compress&cs=tinysrgb&w=800"
  }
];
